const duration=[


    {label:"Duration:",
    controlType:"radio button",
    options:["Days", "Weeks","Months","Years"]
    }


]

export default duration
